

import React from "react";
import styled from "styled-components";
import MenuPageSkeletonItem from "./../../atoms/MenuPageSkeletonItem";

const Wrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;

function MenuPageSkeletonLoader() {
    return (
        <Wrap>
            <MenuPageSkeletonItem/>
            <MenuPageSkeletonItem/>
            <MenuPageSkeletonItem/>
            <MenuPageSkeletonItem/>
        </Wrap>
    );
}

export default MenuPageSkeletonLoader;

